import { Environment } from './environment.model';

/** Configuration for the development environment */
export const environment: Environment = {
  production: false,
  envName: 'dev',
  url: {
    useHash: true,
    host: '//www.dogfood.fashion-concierge.com'
  },
  analytics: {
    ga: 'UA-139960974-2'
  }
};
